import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  Grid,
  Paper,
  TextareaAutosize,
  Typography,
} from '@material-ui/core'
import moment from 'moment'


class TripBookingBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened_feedback: false,
      feedback_message: '',
      submitting_feedback: false,
    };
  }

  render() {
    const { classes, itinerary, travelers, start_date, end_date, nights, currency, isRefundable, minimized } = this.props
    const { opened_feedback, feedback_message, submitting_feedback } = this.state
    const travel_price = (itinerary && itinerary.filter((i) => i.category === 'travel').reduce((acc, current) => acc + current.booking_total_price, 0)) || 0
    const hotel_price = (itinerary && itinerary.filter((i) => i.category === 'accommodation').reduce((acc, current) => acc + current.booking_total_price, 0)) || 0

    // Compact (one-row) booking bar when map expanded
    if (minimized && (travel_price > 0 || hotel_price > 0)) {
      const totalPrice = Math.ceil(((travel_price || 0) + (hotel_price || 0)))
      return (
        <Fragment>
          <Grid container alignItems={'center'} justify={'center'} style={{maxWidth: 1130, margin: '0px auto 12px auto', left: 'auto', zIndex: 2, position: 'relative'}}>
            <Grid item xs={12} md={12} style={{ margin: 'auto'}}>
              <Paper className={`${classes.paper} ${classes.compactPaper}`} elevation={0}>
                <div className={classes.compactRow}>
                  <div className={classes.compactDates}>
                    <div className={classes.compactDatesMain}>{start_date && end_date ? `${moment(start_date).format('MMM D')} – ${moment(end_date).format(moment(start_date).format('MMM') === moment(end_date).format('MMM') ? 'D' : 'MMM D')}` : ''}</div>
                    <div className={classes.compactDatesSub}>{nights ? nights + 1 : 1}-day{(nights || 0) > 0 ? 's' : ''} trip · {travelers} traveler{travelers>1?'s':''}</div>
                  </div>
                  <div className={classes.compactButtonWrap}>
                    <Button
                      variant="contained"
                      disableElevation
                      className={classes.compactBookButton}
                      onClick={() => { console.log('Book now clicked') }}
                    >
                      Reserve for {new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currency: currency || 'USD'}).format(totalPrice)}
                    </Button>
                  </div>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Fragment>
      )
    }

    return (
      <Fragment>
        {(!opened_feedback && (travel_price > 0 || hotel_price > 0) ?
          <Grid container alignItems={'center'} justify={'center'} style={{maxWidth: 1130, margin: 'auto auto 20px auto', left: 'auto', zIndex: 1, position: 'relative'}}>
            <Grid item xs={12} md={12} style={{ margin: 'auto auto auto auto'}}>
              <Paper className={`${classes.paper}`} elevation={0}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{display: 'block', position: 'relative', float: 'none'}}>
                        <Typography className={classes.section} style={{fontSize: 16, border: 'none', float: 'left', display: 'block'}}>
                          <Fragment>{start_date !== end_date ? moment(start_date).format('MMM D - ') : moment(start_date).format('MMM ')} {moment(start_date).format('MMM') === moment(end_date).format('MMM') ? moment(end_date).format('D') : moment(end_date).format('MMM D')}</Fragment> <br/>
                          <small style={{fontWeight: 500, color: '#666', fontSize: '13px'}}>
                            {nights ? nights + 1 : 1}-day{nights > 0 ? 's' : ''} {hotel_price > 0 ? 'stay' : ''} {travel_price && hotel_price ? '&' : ''} {travel_price > 0 ? 'travel' : ''}</small>
                        </Typography>

                        <Typography className={classes.section} style={{fontSize: 20, textAlign: 'right', border: 'none', float: 'right', display: 'block', position: 'absolute', right: 0}}>
                          {new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currency: currency || 'USD'}).format(Math.ceil(((travel_price || 0) + (hotel_price || 0)) / (travelers || 1)))} <br/>
                          <small style={{fontWeight: 500, color: '#666', fontSize: '13px'}}> per person</small>
                        </Typography>
                    </div>
                  </Grid>

                  {/* {travelers > 1 && <Grid item xs={12}>
                    <Typography className={classes.sectionBooking} style={{textAlign: 'right', float: 'right', display: 'block', fontSize: '16px', fontWeight: 600}}>
                      {new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currency: currency || 'USD'}).format(Math.ceil(((travel_price || 0) + (hotel_price || 0))))} <br/>
                    </Typography>
                    <Typography className={classes.sectionBooking} style={{fontSize: '14px', fontWeight: 500}}>
                      Total for {travelers} travelers
                    </Typography>
                  </Grid>} */}

                  {/* Modern Apple-style booking button */}
                  {/* <Grid item xs={12}>
                    <div style={{padding: '20px', borderTop: '1px solid #e5e5e7'}}>
                      <Button
                        variant="contained"
                        fullWidth
                        className={classes.modernBookingButton}
                        onClick={() => {
                          // Add booking functionality here
                          console.log('Book now clicked');
                        }}
                      >
                        Reserve for {new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currency: currency || 'USD'}).format(Math.ceil(((travel_price || 0) + (hotel_price || 0))))}
                      </Button>
                      <Typography style={{textAlign: 'center', fontSize: '12px', color: '#666', marginTop: '8px'}}>
                        You won't be charged yet
                      </Typography>
                    </div>
                  </Grid> */}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        :
          <Fragment></Fragment>
        )}
        {isRefundable && <Grid container alignItems={'center'} justify={'center'} style={{maxWidth: 1130, margin: '20px auto 20px auto', left: 'auto'}}>
            <Grid item xs={12} md={12} style={{ margin: 'auto auto auto auto'}}>
              <Paper className={classes.refundPaper} elevation={0}>
                <Grid container>
                  <Grid item xs={12}>
                    {!opened_feedback ? <div style={{display: 'block', position: 'relative', float: 'none', textAlign: 'center', fontWeight: 500, fontSize: '14px', padding: '16px'}}>
                        Not satisfied with travel plan? <a style={{color: '#007AFF', textDecoration: 'none', marginLeft: '5px', cursor: 'pointer', fontWeight: 600}} onClick={() => this.setState({opened_feedback: true, feedback_message: ''})}>Get a refund</a>
                    </div>
                    :
                    <div className={classes.feedback}>
                        <div style={{margin: '0px 0px 15px 0px', fontWeight: 600, fontSize: '16px', color: '#333'}}>What didn't you like about the travel plan?</div>
                        <TextareaAutosize
                          autoFocus={true}
                          id="feedback_message"
                          placeholder=""
                          variant="outlined"
                          name="feedback_message"
                          rows={2}
                          value={feedback_message}
                          onChange={e => this.setState({feedback_message: e.target.value})}
                          className={classes.textfieldArea}
                        />
                        <br/>
                        <Button variant="contained" color="primary" size="small" disableElevation className={classes.buttonCancel} onClick={() => this.setState({opened_feedback: false, feedback_message: ''})} style={{marginRight: '10px'}}>
                          Cancel
                        </Button>
                        <Button disabled={!feedback_message || submitting_feedback} variant="contained" color="primary" size="small" disableElevation className={classes.buttonBook} onClick={() => {this.setState({submitting_feedback: true}); this.props.onRefund(feedback_message)}} >
                          {submitting_feedback ? 'Refunding...' : 'Refund the plan'}
                        </Button>
                    </div>}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>}
      </Fragment>
    )
  }
}

const styles = theme => ({
  header: {
    padding: '0px !important',
  },
  section: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '20px',
    padding: '20px 20px 15px 20px',

    '& small': {
      color: '#666',
      fontSize: '13px',
      fontWeight: 500,
    }
  },
  sectionPrice: {
    fontSize: 13,
    fontWeight: 800,
    textAlign: 'right',
    padding: '18px 15px',

    '& small': {
      fontSize: '80%',
      fontWeight: 500,
      color: '#777',
    }
  },
  sectionBooking: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    padding: '15px 20px',
    borderTop: '1px solid #e5e5e7',
    color: '#333',

    '& small': {
      color: '#666',
      fontSize: '13px',
      fontWeight: 500,
    },
  },
  skeleton: {
    borderRadius: 10,
  },
  paper: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    border: '1px solid #e5e5e7',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  compactPaper: {
    padding: '10px 17px',
    height: 63, // Match SearchPanel height
    display: 'flex',
    alignItems: 'center',
    borderRadius: 12, // Keep same as expanded booking box
    marginRight: -2,
  },
  compactRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 24,
    width: '100%',
  },
  compactDates: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.2,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: 'hidden',
  },
  compactDatesMain: {
    fontSize: 16,
    fontWeight: 600,
    color: '#111',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  compactDatesSub: {
    fontSize: 13,
    fontWeight: 500,
    color: '#666',
    marginTop: 2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  compactButtonWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  compactBookButton: {
    backgroundColor: '#02c39a',
    color: '#fff',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: 8,
    padding: '12px 22px',
    lineHeight: 1.2,
    fontSize: 16,
    boxShadow: 'none',
    height: 47, // Leaves vertical padding inside 63px container
    '&:hover': {
      backgroundColor: '#029e83',
      boxShadow: 'none',
    }
  },
  refundPaper: {
    backgroundColor: '#F8F9FA',
    boxShadow: 'none',
    border: '1px solid #e5e5e7',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  feedback: {
    display: 'block',
    position: 'relative',
    float: 'none',
    textAlign: 'center',
    margin: '0px',
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRadius: '12px',
    border: '1px solid #e5e5e7'
  },
  modernBookingButton: {
    backgroundColor: '#02c39a',
    color: '#fff',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'none',
    borderRadius: '8px',
    padding: '14px 24px',
    boxShadow: 'none',
    border: 'none',

    '&:hover': {
      backgroundColor: '#029e83',
      boxShadow: 'none',
    },

    '&:active': {
      backgroundColor: '#01826b',
    },

    '&:disabled': {
      backgroundColor: '#C7C7CC',
      color: '#fff',
    }
  },
  buttonBook: {
    color: '#fff',
    backgroundColor: '#FF3B30',
    textTransform: 'none',
    borderRadius: '8px',
    fontWeight: 600,
    padding: '10px 20px',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: '#D70015',
      boxShadow: 'none',
    }
  },
  buttonCancel: {
    backgroundColor: '#F2F2F7',
    color: '#333',
    textTransform: 'none',
    borderRadius: '8px',
    fontWeight: 600,
    padding: '10px 20px',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: '#E5E5EA',
      boxShadow: 'none',
    }
  },
  textfieldArea: {
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#fff',
    borderRadius: '8px',
    margin: '10px 0px',
    fontSize: 14,
    fontWeight: 500,
    padding: '12px 16px',
    border: '1px solid #d1d1d6',
    fontFamily: 'inherit',
    minHeight: 40,
    maxWidth: '98%',
    minWidth: '98%',
    transition: 'border-color 0.2s ease',

    '&:focus': {
      outline: 0,
      borderColor: '#007AFF',
    },
    '& fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 8,
      paddingLeft: 16,
    },
    '&:hover fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 8,
      paddingLeft: 16,
    },
    '&::placeholder': {
      color: '#8E8E93',
    },
  },
})

export default withRouter(withStyles(styles)(TripBookingBox))
